import CopyDirPlugin from 'copy-webpack-plugin';

export default (dirs = [], opts = {}) => (
  new CopyDirPlugin(dirs, opts)
);
